import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import Decimal from 'decimal.js';
import { InvoiceIssuer } from '../billing/invoice-issuer';
import { InvoiceIssuerBank } from '../billing/invoice-issuer-bank';
import { InvoiceReceiver } from '../billing/invoice-receiver';
import { SalesInvoiceWithNewNumber } from '../billing/sales-invoice-with-new-number';
import { HttpService } from '../service/http.service';
import { VatRate } from '../billing/vat-rate';
import { InvoiceLineItem } from '../billing/invoice-line-item';

@Component({
  selector: 'app-create-sales-invoice',
  templateUrl: './create-sales-invoice.component.html',
  styleUrls: ['./create-sales-invoice.component.css']
})
export class CreateSalesInvoiceComponent implements OnInit {

  invoiceForm!: FormGroup;
  receiverForm!: FormGroup;
  issuer: InvoiceIssuer = new InvoiceIssuer(
    "Langues Vivantes sprl",
    [],
    "1000",
    "Rue John Waterloo Wilson 28",
    "BE 0448.926.985",
    "Bruxelles",
    1
  );
  issuerBank: InvoiceIssuerBank = new InvoiceIssuerBank(
    "ING", 
    "BE20310147592256",
    "BBRUBEBB",
    1
  );
  year: number = moment().year();
  sequenceNumber!: number;
  //default vat rate = 21% (vateRates[0])
  vatRates: VatRate[] = [];
  invoiceReceivers: InvoiceReceiver[] = [];
  activeReceiverForm = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.httpService.getAllVatRates().subscribe(rates => {
      this.vatRates = rates;
      this.invoiceForm = this.builder.group({
        invoiceReceiver: [null, Validators.required],
        lineItems: this.builder.array([])
      });
    });
    this.getInvoiceReceivers();
    this.httpService.getLastInvoiceNumber().subscribe(res => {
      console.log("last invoice number: " + res);
      console.log("invoice number length: " + res.toString().length);
      this.sequenceNumber = res + 1;
    });
    this.initReceiverForm();
  }

  getInvoiceReceivers(){
    this.httpService.getAllInvoiceReceivers().subscribe(res => {
      this.invoiceReceivers = res;
    });
  }

  initReceiverForm(){
    this.receiverForm = this.builder.group({
      name: [null, Validators.required],
      street: [null, Validators.required],
      vatNumber: [null, Validators.required],
      postCode: null,
      city: [null, Validators.required],
      option: null,
      id: null,
    });
  }

  mouseover(i: number) {
    let array = this.invoiceForm.get("lineItems") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.invoiceForm.get("lineItems") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.invoiceForm.get("lineItems") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.invoiceForm.get("lineItems") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.invoiceForm.get("lineItems") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      description: "",
      netAmount: [new Decimal(0.00), Validators.pattern(/^[.\d]+$/)],
      vatRate: this.vatRates[0], 
      activeMenu: false,
      id: null
    }));
  }

  setItemsToInvoice(invoice: SalesInvoiceWithNewNumber){
    invoice.items = [];
    let itemArray = this.invoiceForm.get("lineItems") as FormArray;
    for(let itemForm of itemArray.controls){
      invoice.items.push(new InvoiceLineItem(
        itemForm.value.netAmount,
        itemForm.value.vatRate,
        itemForm.value.description
      ));
    }
  }

  postInvoice(){
    if(this.invoiceForm.invalid){
      return;
    }
    let invoice = new SalesInvoiceWithNewNumber(
      //send null for invoice number string. backend will make it with sequenceNumber and year.
      null,
      [],
      this.issuer,
      this.invoiceForm.value.invoiceReceiver,
      true,
      this.issuerBank,
      this.sequenceNumber,
      this.year
    );
    this.setItemsToInvoice(invoice);
    this.httpService.postSalesInvoice(invoice).subscribe(() => {
      console.log("success");
    });
  }

  activateReceiverForm(){
    this.activeReceiverForm = true;
  }

  postReceiver(){
    let receiver = new InvoiceReceiver(
      this.receiverForm.value.name,
      true,
      this.receiverForm.value.vatNumber,
      this.receiverForm.value.city,
      this.receiverForm.value.postCode,
      this.receiverForm.value.street,
      this.receiverForm.value.option,
      null
    );
    this.httpService.postInvoiceReceiver(receiver).subscribe(res => {
      receiver.id = res;
      this.invoiceForm.get("invoiceReceiver")!.setValue(receiver);
      this.getInvoiceReceivers();
      this.initReceiverForm();
      this.activeReceiverForm = false;
    });
  }

  isHidden(i: number){
    let itemsFormArray = this.invoiceForm.get('lineItems') as FormArray;
    return itemsFormArray.controls[i].get('activeMenu')!.value?false:true;
  }

  get lineItemsFormArray(){
    let formArray = this.invoiceForm.get('lineItems') as FormArray;
    return formArray.controls;
  }

}
